export default __webpack_public_path__ + "static/media/NewYearResolution_20.19b526a6.png";